<footer class="app-footer">
    <div class="container-fluid text-right">
        <a href="#">Cerrar sesión</a>
    </div>
</footer>
